import { EntityState } from "./entity-state"
import { EntityAction, EntityActionTypeEnum } from "./entity-action"

const initialState: EntityState = {
    entitiesLoadInProgress: false,
    entities: [],
    selectedEntity: null,
    journeyTasksLoadInProgress: false,
    initialJourneyTasks: null,
    initialJourneyTasksLoaded: false,
    latestJourneyTasks: null,
    latestJourneyTasksLoaded: false,
    selectedJourneyTask: null,
    dataGroups: null,
    dataGroupsLoadInProgress: false,
    documentsLoadInProgress: false,
    documents: null,
    documentRequirementsLoadInProgress: false,
    documentRequirements: null,
    documentDownloadUrls: {},
    documentDownloadUrlsLoadInProgress: false,
    entityDraft: null,
    entityDraftLoadInProgress: false,
    lookups: null,
    lookupsLoadInProgress: false,
    lookupLinks: null,
    lookupLinksLoadInProgress: false,
    associations: null,
    associationsLoadInProgress: false,
    peopleEntitiesList: null,
    peopleEntitiesListLoadInProgress: false,
    allPeopleEntitiesList: null,
    verifyEntityInformationOpen: false,
    verifyingEntityInformation: false,
    dynamicRequirementsLoadInProgress: false,
    dynamicRequirements: [],
    dynamicJurisdictions: [],
    codatIntegration:[],
    codatIntegrationLoadInProgress: false
}
export const entityReducer = (
    state: EntityState = initialState,
    action: EntityAction
): EntityState => {
    switch (action.type) {
        case EntityActionTypeEnum.SET_ENTITIES_LOAD_IN_PROGRESS:
            return {
                ...state,
                entitiesLoadInProgress: action.data,
            }
        case EntityActionTypeEnum.SET_ENTITIES:
            return {
                ...state,
                entitiesLoadInProgress: false,
                entities: action.data
            }
        case EntityActionTypeEnum.SET_SELECTED_ENTITY:
            return {
                ...state,
                selectedEntity: action.data
            }
        case EntityActionTypeEnum.SET_ENTITY_DRAFT_LOAD_IN_PROGRESS:
            return {
                ...state,
                entityDraftLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_ENTITY_DRAFT:
            return {
                ...state,
                entityDraft: action.data
            }
        case EntityActionTypeEnum.SET_JOURNEY_TASKS_LOAD_IN_PROGRESS:
            return {
                ...state,
                journeyTasksLoadInProgress: action.data,
            }
        case EntityActionTypeEnum.SET_INITIAL_JOURNEY_TASKS:
            return {
                ...state,
                initialJourneyTasks: action.data,
                initialJourneyTasksLoaded: true
            }
        case EntityActionTypeEnum.SET_LATEST_JOURNEY_TASKS:
            return {
                ...state,
                latestJourneyTasks: action.data,
                latestJourneyTasksLoaded: true
            }
        case EntityActionTypeEnum.SET_SELECTED_JOURNEY_TASK:
            return {
                ...state,
                selectedJourneyTask: action.data
            }
            case EntityActionTypeEnum.SET_CODAT_INTEGRATION_LOAD_IN_PROGRESS:
            return {
                ...state,
                codatIntegrationLoadInProgress: action.data
            }
            case EntityActionTypeEnum.SET_CODAT_INTEGRATION:
                return {
                    ...state,
                    codatIntegration: action.data
                }
        case EntityActionTypeEnum.SET_LOOKUPS_LOAD_IN_PROGRESS:
            return {
                ...state,
                lookupsLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_LOOKUPS:
            return {
                ...state,
                lookups: action.data
            }
        case EntityActionTypeEnum.SET_LOOKUP_LINKS_LOAD_IN_PROGRESS:
            return {
                ...state,
                lookupLinksLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_LOOKUP_LINKS:
            return {
                ...state,
                lookupLinks: action.data
            }
        case EntityActionTypeEnum.SET_DATA_GROUPS_LOAD_IN_PROGRESS:
            return {
                ...state,
                dataGroupsLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_DATA_GROUPS:
            return {
                ...state,
                dataGroups: action.data
            }
        case EntityActionTypeEnum.SET_ASSOCIATIONS_LOAD_IN_PROGRESS:
            return {
                ...state,
                associationsLoadInProgress: action.data,
            }
        case EntityActionTypeEnum.SET_ASSOCIATIONS:
            return {
                ...state,
                associations: action.data
            }
        case EntityActionTypeEnum.SET_PEOPLE_ENTITIES_LIST_LOAD_IN_PROGRESS:
            return {
                ...state,
                peopleEntitiesListLoadInProgress: action.data,
            }
        case EntityActionTypeEnum.SET_PEOPLE_ENTITIES_LIST:
            return {
                ...state,
                peopleEntitiesList: action.data
            }
        case EntityActionTypeEnum.SET_ALL_PEOPLE_ENTITIES_LIST:
            return {
                ...state,
                allPeopleEntitiesList: action.data
            }
        case EntityActionTypeEnum.SET_DOCUMENT_REQUIREMENTS_LOAD_IN_PROGRESS:
            return {
                ...state,
                documentRequirementsLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_DOCUMENT_REQUIREMENTS:
            return {
                ...state,
                documentRequirements: action.data
            }
        case EntityActionTypeEnum.SET_DOCUMENTS_LOAD_IN_PROGRESS:
            return {
                ...state,
                documentsLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_DOCUMENTS:
            return {
                ...state,
                documents: action.data
            }
        case EntityActionTypeEnum.SET_DOCUMENT_DOWNLOAD_URL_LOAD_IN_PROGRESS:
            return {
                ...state,
                documentDownloadUrlsLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_DOCUMENT_DOWNLOAD_URL:
            return {
                ...state,
                documentDownloadUrls: {
                    ...state.documentDownloadUrls,
                    [action.data['documentId']]: action.data['downloadUrl']
                }
            }
        case EntityActionTypeEnum.SET_ENTITY:
            return {
                ...action.data
            }
        case EntityActionTypeEnum.SET_VERIFY_ENTITY_INFORMATION_OPEN:
            return {
                ...state,
                verifyEntityInformationOpen: action.data
            }
        case EntityActionTypeEnum.SET_VERIFYING_ENTITY_INFORMATION:
            return {
                ...state,
                verifyingEntityInformation: action.data
            };
        case EntityActionTypeEnum.SET_DYNAMIC_REQUIREMENTS_LOAD_IN_PROGRESS:
            return {
                ...state,
                dynamicRequirementsLoadInProgress: action.data
            }
        case EntityActionTypeEnum.SET_DYNAMIC_REQUIREMENTS:
            return {
                ...state,
                dynamicRequirements: action.data
            }
        case EntityActionTypeEnum.SET_JURISDICTIONS:
            return {
                ...state,
                dynamicJurisdictions: action.data,
            }
        default:
            return state;

    }
}

export default entityReducer